import toast from "react-hot-toast";

// ----------------success-message----------------
const successMessage = (res) => {
  if (!res) return;

  const message =
    typeof res === "string"
      ? res
      : res?.message || res?.data?.message || "Operation successful";

  toast.success(message, { id: 'successResponse' });
};

// ----------------error-message----------------
const failMessage = (res) => {
  if (!res) return;
  // console.log('res tost', res)
  const message =
    (typeof res === "string"
      ? res
      : res?.message) ||
    res?.data?.message ||
    res?.error
  // ||
  // "Something went wrong";



  toast.error(message, { id: 'failResponse' });
};

export { successMessage, failMessage };
